import type { FaireProductEntity } from "../../entity_types/product";

export const p_psb59gs7zu: FaireProductEntity = {
  token: "p_psb59gs7zu",
  type: "product",
  name: "Dido Earrings | Double Pearl Ball Modern Design Stud",
  brandToken: "b_493edh35w5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b0f3470f62dea1c4689afdcd6ac900a3a4db65fc1f1483a672c7c8946630ae71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bfe3bad570d95daeb0a6b39e00474a258ca09c8561ae0c64264015e0fc8a671.jpeg",
    "https://cdn.faire.com/fastly/58485710d95eee82adbac1253ee6b3a6165ccba59a2b251e097e4fcde171578d.jpeg",
    "https://cdn.faire.com/fastly/03c3c1fe633c382c3b1fcf2ac8ce3d443086d152e126b7b5985adbbfb20e8cd4.jpeg",
  ],
  priceDollars: 9.7,
  description:
    "Embrace timeless elegance with the Dido Earrings. These stunning double pearl ball stud earrings feature a 6mm pearl set on a cubic adorned bar stud, complemented by a 12mm pearl dangle at the bottom. The combination of classic pearls with sparkling cubic zirconia adds a touch of sophistication to any outfit, making these earrings perfect for both everyday wear and special occasions.\n\nTo maintain the beauty of your Dido Earrings, please handle them with care. Avoid contact with water, perfumes, and lotions to prevent tarnishing. Store them in a dry, cool place when not in use, and clean gently with a soft, dry cloth to keep them shining.\n\nMaterials: Nickel-free plated brass base, Silver 925 post, Acrylic pearl balls\nSize: Cubic post - 1.5x7mm, Pearls - 6mm and 12mm",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:15.938Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
